import { render, staticRenderFns } from "./webhook_config.vue?vue&type=template&id=18dfda0c&scoped=true&"
import script from "./webhook_config.vue?vue&type=script&lang=js&"
export * from "./webhook_config.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18dfda0c",
  null
  
)

export default component.exports